import React, { FC } from 'react';
import { Success as SuccessComponent } from '../../shared/components/Success/success.component';
import { stepper } from '../stepper.config';

export const Success: FC = () => {
  return <SuccessComponent stepperConfig={stepper} />;
};
